export default {
    toggleLanguageText: 'Español',
    changePasswordTitle: 'Change Password',
    changePasswordHelpText: 'Enter your new password',
    changePasswordSuccessful: 'Successfuly changed password',
    changePasswordFail: 'Supplier update error',
    newUploadTitle: 'New Upload',
    newUploadHelperText1: 'You can select your files through the Path field',
    newUploadHelperText2: 'or simply drag and drop them over this table.',
    newUploadAddButtonText: 'Add',
    newUploadUploadButtonText: 'Upload',
    newUploadHeaderFile: 'File',
    newUploadHeaderSize: 'Size',
    newUploadConfirmationTitle: 'Confirmation',
    newUploadConfirmationText: 'Are you sure you want to remove this file from the upload list?',
    newUploadFileRestrictionsText: 'Only files with image, PDF, Excel or XML extensions are allowed.',
    newUploadInternationalRestrictionsText: 'Only files with image, Excel or PDF extensions are allowed.',
    newUploadNationalRestrictionsText: 'Only files with XML extension are allowed.',
    newUploadHelperText3: 'The file ',
    newUploadAlreadySelected: ' has already been selected.',
    newUploadAlreadyAdded: ' has already been added to the upload list.',
    newUploadNeedsFileToAdd: 'Please select at least one file.',
    newUploadNeedsFileToUpload: 'Please add at least one file to the upload list.',
    newUploadSuccess: 'The file list has been successfuly uploaded.',
    newUploadSizeOverflow: "The total file size exceeds the server's allowed limits.",
    newUploadError: 'An error occured during the file upload. Please try again later.',
    newUploadRemoveFile: 'The file has been successfuly removed from the upload list',
    newUploadNationalSupplierFilesError: 'National Suppliers must upload at least one PDF and XML file',
    newUploadFileNameError: 'The name of the PDF file must match an XML file.',
    menuTracking: 'Tracking',
    menuNewUpload: 'New upload',
    menuPaymentStatus: 'Payment status',
    menuChangePassword: 'Change password',
    menuSignOut: 'Sign out',
    paymentStatusTitle: 'Payment Status',
    paymentStatusHelpText: 'Whirlpool commited with the quality of their processes and compliance of each objective from the strategy, it supplies an E-Payments platform with the goal of provide always the best information to our strategic partners.',
    paymentStatusButtonText: 'Go to site',
    trackingTitle: 'Tracking',
    trackingExportButtonText: 'Export CSV',
    trackingToggleFiltersButtonText: 'Filters',
    trackingNewButtonText: 'New',
    trackingHeaderInvoiceNo: 'Invoice No.',
    trackingHeaderRelatedDoc: 'Related doc.',
    trackingHeaderRemission: 'Remission',
    trackingHeaderUploadDate: 'Upload date',
    trackingHeaderInvoiceDate: 'Invoice date',
    trackingHeaderStatus: 'Status',
    trackingHeaderDetails: 'Details',
    trackingHeaderPhase: 'Phase',
    trackingHeaderAutomaticNotes: 'Automatic notes',
    trackingHeaderManualNotes: 'Manual comments',
    loginWelcomeText: "Welcome",
    loginSupplierText: "Supplier",
    loginTitle: "User access",
    loginSignup: 'Sign up',
    loginButtonText: 'Log in',
    loginRecoverText: 'If you do not have your access credentials, please send an email to ',
    loginRecoverStrongText: 'MEX_AP_SUPPORT@WHIRLPOOL.COM or call 52 8183 29 00 00.',
    loginHelpText: "If you do not view the ads, please activate the pop-ups of your browser.",
    loginWrongCredentials: "Wrong credentials.",
    loginEmptyFields: "Please fill out all fields.",
    loginRecoveryLink: "Forgot password?",

    passwordRecoveryFormTitle: "Password recovery form",
    passwordRecoveryFormSubtitle: "Enter your email address to receive a password recovery email",
    passwordRecoveryFormEmailLabel: "Email",
    passwordRecoveryFormInvalidEmail: "Email is invalid",
    passwordRecoveryFormReturnLink: "Return to login",
    passwordRecoveryFormSuccess: "Email was sent",
    passwordRecoveryFormFail: "There was a problem sending the email",
    
    passwordRecoveryTitle: "Password recovery",
    passwordRecoverySubtitle: "Enter new Password",
    passwordRecoveryNewPasswordLabel: "New Password",
    passwordRecoveryConfirmPasswordLabel: "Confirm Password",
    passwordRecoveryPasswordsDoNotMatch: "Passwords do not match",
    passwordRecoveryInvalidToken: "Invalid recovery link",
    passwordRecoveryInvalidPassword: "This password is invalid",
    passwordRecoverySuccess: "Your password was changed",
    passwordRecoveryFail: "There was a problem changing your password",
    passwordRecoveryFailCode4: "Password must have 8 characters at least",

    signupHelpText: '*The password will be the same as the TAX ID, it can be changed at your log in',
    signupSuccessful: 'Sign up successful',
    signupFail: 'Supplier creation error',
    signupFailCodeNotFound: 'Vendor Number not found',
    signupFailCodeTaken: 'Vendor Number is taken',
    signupFailRfcNoMatch: 'Tax ID does not match',
    signupFailEmailTaken: 'Email is taken',
    versionRetrievalFail: 'Failed to retrieve version',
    formBusinessName: 'Business name',
    formContactEmail: 'Email',
    formTaxID: 'Tax ID',
    formSupplierCode: 'Vendor Number',
    formContactName: 'Contact name',
    formContactPhone: 'Phone number',
    formPassword: 'Password',
    formNewPassword: 'New password',
    formConfirmNewPassword: 'Confirm new password',
    formRequiredField: 'Required field',
    formInvalidInput: 'Invalid input',
    formRequiredPhoneFormat: 'Country code (1-3 digits) expected followed by 10 digits (e.g. +1 619 123 4567)',
    formDifferentPasswords: 'Passwords do not match',
    formPath: 'Path',
    formInvoiceNo: 'Invoice No.',
    formInvoiceDate: 'Invoice date',
    formStatus: 'Status',
    backButtonText: 'Back',
    saveButtonText: 'Save',
    dataTableNoFiles: 'No files selected for upload.',
    dataTableNoData: 'No entries found that match selection criteria. Please try another search or create a new entry.',
    datetimePickerAccept: "Accept",
    datetimePickerCancel: "Cancel",
    datetimePickerClean: "Clean",
    statusKey: 'englishText',
    noComments: 'No comments',
    noRelatedDoc: 'None',
    noRemissionAssinged: 'None',

    dialogBtnClose: 'Close',
    dialogBtnSave: 'Save',
    dialogRequiredFields: 'Required fields',
    dialogTitle: 'Related Doc',
    dialogValidationSelect: 'Must select an option',
    dialogValidationText: 'Must not be empty',
    relatedDocConsignment: 'Consignment',
    relatedDocPO: 'Purchase order',
    relatedDocShipmentNum: 'Shipment no.',
    relatedDocTypeTitle: 'Type *',
    relatedDocTypeValue: 'Related doc no. *',
    relatedDocAssignedMessage: 'Related document assigned',
    relatedDocErrorMessage: 'Error while assigning document',
    getSupplierTypeErrorMessage: 'Error while getting supplier type',
    remissionTitle: 'Remission',
    remissionText: 'Type remission number *',

    noTemplate: "You cannot upload files at the moment. Your template has not been registered by our team. Please contact us for any questions.",
    
    trackingInvalidPageNumber: 'The page number typed doesn\'t exist',
    trackingErrorGetList: 'There was a problem getting the list',
    trackingErrorGetStatuses: 'There was a problem getting the statuses list',
    trackingErrorProcessCSV: 'There was a problem processing the CSV'
}